var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-swiper[data-v-4f46f01e],.bg-swiper__slide[data-v-4f46f01e]{width:100%;height:100%;background-color:#fff}.bg-swiper__slide[data-v-4f46f01e]{background-position:50%;background-repeat:no-repeat;-webkit-background-size:cover;background-size:cover;position:absolute;top:0;left:0;z-index:1}.re[data-v-4f46f01e]{background-image:url(" + escape(require("../assets/re.jpg")) + ")}.ls[data-v-4f46f01e]{background-image:url(" + escape(require("../assets/ls.jpg")) + ")}.it[data-v-4f46f01e]{background-image:url(" + escape(require("../assets/it.jpg")) + ")}.it2[data-v-4f46f01e]{background-image:url(" + escape(require("../assets/it-2.jpg")) + ")}.swiper-container[data-v-4f46f01e]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f46f01e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Swiper.vue
// module id = 20
// module chunks = 0